var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('img',{staticClass:"Vuelogo",attrs:{"src":require("./assets/logo.png")}}),_c('div',{staticClass:"text"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn"}},[_vm._v("粤ICP备2023045222号-1")])])])
}]

export { render, staticRenderFns }